import type { FileProviderType } from './constants';
import { isAttachmentDataProviderTypeEnabled } from 'owa-add-fileprovider';

// returns whether a fileprovider is enabled throughout OWA
export default function isFileProviderEnabled(provider: FileProviderType): boolean {
    return isAttachmentDataProviderTypeEnabled(provider);
}
